module.exports = __webpack_public_path__ + "img/1-26.74545d77.jpg";